module.exports = __webpack_public_path__ + "img/first-time-buyer-2.fedcbf4f.jpg";